var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCinimexWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 340.2 116.2",
    style: {
      enableBackground: "new 0 0 340.2 116.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F18A00;}\n\t.st1{fill:#003B71;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 31.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.0411 51.6201)",
    className: "st0",
    width: 13.5,
    height: 13.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.7,
    y: 43.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.7128 67.7507)",
    className: "st1",
    width: 13.5,
    height: 21.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.4,51.2 43.9,41.7 28.7,56.9 57.2,85.5 72.5,70.3 63,60.7 57.2,66.5 47.7,56.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.1,82.2h-5.3V72.1h5.1c0.9,0,1.6,0.2,2,0.6s0.6,1,0.6,1.9c0,0.4,0,0.8-0.1,1.1c-0.1,0.3-0.2,0.5-0.4,0.7 s-0.5,0.4-0.9,0.5c0.5,0.1,0.8,0.3,1,0.5s0.4,0.5,0.5,0.8s0.1,0.7,0.1,1.2c0,1-0.2,1.7-0.6,2.2C146.7,82,146.1,82.2,145.1,82.2z  M140.9,73.1v3.4h3.3c0.5,0,0.9-0.1,1.2-0.2s0.5-0.3,0.6-0.5c0.1-0.3,0.2-0.6,0.2-1.1c0-0.6-0.1-1-0.3-1.3 c-0.2-0.2-0.7-0.3-1.3-0.3H140.9z M140.9,77.5v3.7h3.2c0.5,0,0.9,0,1.2-0.1c0.3,0,0.5-0.1,0.7-0.2s0.3-0.3,0.4-0.5 c0.1-0.2,0.1-0.6,0.1-1c0-0.6-0.1-1-0.2-1.2c-0.1-0.3-0.3-0.4-0.6-0.5s-0.7-0.1-1.2-0.1h-3.6V77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.1,81l2.4-5.9h1.8v7.1h-1.1V76l-2.6,6.2h-1L151,76v6.2h-1.1v-7.1h1.8L154.1,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.8,78.9h-5.3c0,0.6,0,1,0.1,1.3s0.2,0.6,0.3,0.8c0.1,0.2,0.4,0.3,0.6,0.4c0.3,0.1,0.6,0.1,1.1,0.1 c0.6,0,1,0,1.3-0.1s0.5-0.2,0.6-0.4c0.1-0.2,0.2-0.4,0.2-0.8V80h1.1c0,0.7-0.1,1.1-0.4,1.5c-0.2,0.3-0.6,0.6-1,0.7 s-1,0.2-1.8,0.2s-1.5-0.1-1.9-0.3c-0.5-0.2-0.8-0.6-1-1.1s-0.3-1.3-0.3-2.3c0-0.7,0.1-1.3,0.2-1.8c0.1-0.5,0.3-0.8,0.6-1.1 c0.3-0.3,0.6-0.5,1-0.6s0.9-0.2,1.5-0.2c1.1,0,2,0.3,2.5,0.8s0.7,1.4,0.7,2.6v0.5H166.8z M165.7,78c0-0.6-0.1-1-0.2-1.3 c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.7-0.2-1.2-0.2s-0.9,0.1-1.2,0.2s-0.5,0.4-0.6,0.7c-0.1,0.3-0.2,0.7-0.2,1.3H165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174,79.6h1.1c0,0.6-0.1,1-0.2,1.4c-0.1,0.4-0.3,0.6-0.5,0.8c-0.2,0.2-0.6,0.3-0.9,0.4 c-0.4,0.1-0.9,0.1-1.4,0.1c-0.6,0-1.1-0.1-1.5-0.2s-0.7-0.3-1-0.6c-0.2-0.3-0.4-0.6-0.5-1.1s-0.2-1.1-0.2-1.8 c0-0.9,0.1-1.7,0.3-2.2s0.5-0.9,1-1.1c0.4-0.2,1.1-0.3,1.9-0.3c0.7,0,1.2,0.1,1.7,0.2c0.4,0.1,0.8,0.4,1,0.7 c0.2,0.3,0.4,0.8,0.4,1.3v0.2h-1.1c0-0.4-0.1-0.7-0.1-0.9c-0.1-0.2-0.3-0.4-0.6-0.5s-0.7-0.1-1.3-0.1s-1,0.1-1.3,0.2 s-0.5,0.4-0.6,0.8s-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8c0.1,0.4,0.3,0.7,0.6,0.8c0.3,0.1,0.7,0.2,1.3,0.2c0.4,0,0.8,0,1-0.1 c0.3-0.1,0.5-0.1,0.6-0.3c0.1-0.1,0.2-0.3,0.3-0.5C173.9,80.4,174,80,174,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.8,76h-2.5v-0.9h6.2V76H180v6.2h-1.1L178.8,76L178.8,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.1,78.9h-5.3c0,0.6,0,1,0.1,1.3s0.2,0.6,0.3,0.8c0.1,0.2,0.4,0.3,0.6,0.4c0.3,0.1,0.6,0.1,1.1,0.1 c0.6,0,1,0,1.3-0.1s0.5-0.2,0.6-0.4c0.1-0.2,0.2-0.4,0.2-0.8V80h1.1c0,0.7-0.1,1.1-0.3,1.5c-0.2,0.3-0.6,0.6-1,0.7 s-1,0.2-1.8,0.2s-1.5-0.1-1.9-0.3c-0.5-0.2-0.8-0.6-1-1.1s-0.3-1.3-0.3-2.3c0-0.7,0.1-1.3,0.2-1.8c0.1-0.5,0.3-0.8,0.6-1.1 c0.3-0.3,0.6-0.5,1-0.6s0.9-0.2,1.5-0.2c1.1,0,2,0.3,2.5,0.8s0.7,1.4,0.7,2.6v0.5H190.1z M189,78c0-0.6-0.1-1-0.2-1.3 c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.7-0.2-1.2-0.2s-0.9,0.1-1.2,0.2s-0.5,0.4-0.6,0.7c-0.1,0.3-0.2,0.7-0.2,1.3H189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.7,76.4c0.2-0.4,0.5-0.7,0.8-0.8c0.3-0.2,0.8-0.3,1.4-0.3c0.9,0,1.5,0.1,2,0.3c0.5,0.2,0.8,0.6,1,1.1 s0.3,1.2,0.3,2c0,0.7,0,1.2-0.1,1.6s-0.2,0.8-0.5,1.1c-0.2,0.3-0.6,0.5-1,0.7s-1,0.2-1.7,0.2s-1.2-0.1-1.6-0.2 c-0.4-0.2-0.7-0.4-1-0.7c-0.2-0.3-0.4-0.7-0.5-1.1s-0.1-1-0.1-1.6v-2.2c0-2.4,1-3.5,3-3.5c0.6,0,1.1,0,1.3,0 c0.3,0,0.4-0.1,0.5-0.2s0.1-0.2,0.1-0.4h0.9c0,0.4-0.1,0.7-0.2,0.9c-0.2,0.2-0.4,0.3-0.8,0.4c-0.3,0.1-0.8,0.1-1.4,0.1 c-0.5,0-1,0.1-1.3,0.2s-0.6,0.4-0.8,0.8C196.8,75.1,196.7,75.7,196.7,76.4z M199,81.5c0.6,0,1-0.1,1.3-0.3 c0.3-0.2,0.5-0.5,0.6-0.8c0.1-0.4,0.2-0.9,0.2-1.7c0-0.7-0.1-1.2-0.2-1.6c-0.1-0.4-0.3-0.6-0.6-0.8c-0.3-0.1-0.7-0.2-1.3-0.2 s-1,0.1-1.3,0.2s-0.5,0.4-0.6,0.8s-0.2,0.9-0.2,1.6s0.1,1.3,0.2,1.7c0.1,0.4,0.3,0.7,0.6,0.8C198,81.4,198.4,81.5,199,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.4,75.1h1.1V78h2.7c1.4,0,2.1,0.7,2.1,2.1c0,0.7-0.2,1.3-0.6,1.6c-0.4,0.3-0.9,0.5-1.5,0.5h-3.8V75.1z  M207.8,81.4c0.5,0,0.9-0.1,1.1-0.3c0.2-0.2,0.3-0.5,0.3-1c0-0.3,0-0.6-0.1-0.8c-0.1-0.2-0.2-0.3-0.4-0.4s-0.5-0.1-0.9-0.1h-2.3 v2.5h2.3V81.4z M211.7,75.1h1.1v7.1h-1.1V75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.6,76h-2.5v-0.9h6.2V76h-2.5v6.2h-1.1L216.6,76L216.6,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.8,75.1h1.1V78h2.7c1.4,0,2.1,0.7,2.1,2.1c0,0.7-0.2,1.3-0.6,1.6c-0.4,0.3-0.9,0.5-1.6,0.5h-3.8v-7.1 H221.8z M225.2,81.4c0.5,0,0.9-0.1,1.1-0.3c0.2-0.2,0.3-0.5,0.3-1s-0.1-0.8-0.3-1s-0.6-0.3-1.1-0.3h-2.3v2.5h2.3V81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.2,82.2h-1.1V76H235v4.2c0,1.4-0.6,2-1.8,2h-0.5v-0.9h0.2c0.4,0,0.7-0.1,0.8-0.2s0.2-0.5,0.2-1v-5h5.4 L239.2,82.2L239.2,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M245.7,75.1h1.1l-2.3,8.1c-0.2,0.6-0.3,1.1-0.6,1.4c-0.2,0.3-0.4,0.6-0.7,0.7s-0.6,0.2-1,0.2 c-0.2,0-0.5,0-0.6-0.1v-0.9c0.1,0,0.3,0.1,0.4,0.1c0.3,0,0.5-0.1,0.7-0.2s0.3-0.3,0.4-0.6c0.1-0.3,0.3-0.8,0.5-1.5h-0.5l-2.7-7.1 h1.1l2.3,6.3L245.7,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.2,75.1v7.1h-1.1v-3.7H253c-0.2,0.2-0.4,0.4-0.7,0.5s-0.8,0.1-1.5,0.1c-0.5,0-1-0.1-1.3-0.2 s-0.6-0.3-0.8-0.6c-0.2-0.3-0.3-0.7-0.3-1.2v-2h1.1v1.8c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.2,0.3,0.5,0.4c0.2,0.1,0.5,0.1,1,0.1 c0.8,0,1.5-0.1,1.9-0.3v-2.8h1.2V75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.9,82.2h-10.3v-7.1h1.1v6.2h3.5v-6.2h1.1v6.2h3.5v-6.2h1.1L266.9,82.2L266.9,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.2,82.2v-7.1h1.1v5.8l3.8-5.8h1.4v7.1h-1.1v-5.8l-3.7,5.8h-0.3H269.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.8,81l2.4-5.9h1.8v7.1h-1V76l-2.6,6.2h-1l-2.6-6.2v6.2h-1.1v-7.1h1.8L281.8,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.3,82.2v-7.1h1.1v5.8l3.8-5.8h1.4v7.1h-1.1v-5.8l-3.7,5.8h-0.3H288.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.3,72.1l-0.2,7.4h-1l-0.1-7.4H298.3z M298.3,80.8v1.4h-1.2v-1.4H298.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298.3,47.2 291.1,47.2 281.9,53.8 272.6,47.2 265.4,47.2 265.4,48.7 277.1,57.1 265.4,65.2  265.4,66.7 272.6,66.7 281.9,60.4 291.1,66.7 298.3,66.7 298.3,65.2 286.7,57.1 298.3,48.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.4,52.6v-5.4H94l0,0c-1.5,0-2.7,1.2-2.7,2.7V64l0,0c0,1.5,1.2,2.7,2.7,2.7h31.4v-5.4H96.7v-8.7 C96.7,52.6,125.4,52.6,125.4,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.8,51.7v-4.5h-31.4l0,0c-1.5,0-2.7,1.2-2.7,2.7V64l0,0c0,1.5,1.2,2.7,2.7,2.7h31.4v-4.5h-28.7v-3h25.1 v-4.5h-25.1v-3C233.1,51.7,261.8,51.7,261.8,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.4,47.2v13l-25.1-13h-1.8c-1.5,0-2.7,1.2-2.7,2.7v16.8h5.4V53.2v-0.1l25.2,13.6l0,0h1.8l0,0 c1.5,0,2.7-1.2,2.7-2.7V47.2H169.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.5,47.2h-1.8l-12.6,13.2l-12.6-13.2h-1.8l0,0c-1.5,0-2.7,1.2-2.7,2.7v16.8h5.4V55.9l10.8,10.8h1.8 l10.8-10.8v10.8h5.4V49.9C223.2,48.4,222,47.2,220.5,47.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.2,
    y: 47.2,
    className: "st2",
    width: 5.4,
    height: 19.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.9,
    y: 47.2,
    className: "st2",
    width: 5.4,
    height: 19.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinimexWhitecolor);
export default __webpack_public_path__ + "static/media/Cinimex_white+color.589410141a5b5991f95b8a7d5120fff1.svg";
export { ForwardRef as ReactComponent };